// src/contexts/HealthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import Tools from "../utils/Tools";

const HealthContext = createContext();

export const HealthProvider = ({ children }) => {
    const [healthHistory, setHealthHistory] = useState([]);
    const [modelsUsed, setModelsUsed] = useState([]);
    const [loadingHealthHistory, setLoadingHealthHistory] = useState(true);
    const [stepFunctionErrorHistoryCount, setStepFunctionErrorHistoryCount] = useState(0);

    useEffect(() => {
        setLoadingHealthHistory(true);
        Tools.sendRequest("get-health-status-auth")
            .then((response) => {
                // First record is the latest.
                setHealthHistory(response.healthHistory);
                setModelsUsed(response.modelsUsed);
                setLoadingHealthHistory(false);
                setStepFunctionErrorHistoryCount(response.stepFunctionErrorHistoryCount);
            })
            .catch((error) => {
                console.error("Error fetching summary:", error);
                setLoadingHealthHistory(false);
            });
    }, []);

    return (
        <HealthContext.Provider value={{ healthHistory, loadingHealthHistory, modelsUsed, stepFunctionErrorHistoryCount }}>
            {children}
        </HealthContext.Provider>
    );
};

export const useHealth = () => useContext(HealthContext);